/**
 * Zweck: Beschreibt class PaginatedResult und ihren Daten- oder Funktionsvertrag.
 */
/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/paginated-result.ts.
 */
export class PaginatedResult<T> {
  page: number;
  pages: number;
  count: number;
  data: T[];

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor() {
    this.page = 1;
    this.pages = 1;
    this.count = 0;
    this.data = [];
  }
}
